module.exports = __webpack_public_path__ + "static/media/mod-zimbara.dcecd7cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/mod-zimbara.jpg
// module id = 343
// module chunks = 0